import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { history } from '../_services/essentials/helpers';

export { Authorization };

function Authorization(props) {
    const auth = useSelector(x => x.auth.value);
    const loggedInUserRoles = useSelector(x => x.auth.loggedInUser?.roles);
    const allowedRoles = props.for;

    if(auth) {
        if (!loggedInUserRoles?.some(role => allowedRoles.includes(role.name))) {
            return <Navigate to="/error/not_authorized"/>
        } else {
            return (
                <React.Fragment>
                    {props.children}
                </React.Fragment>
            );
        }

    } else {
        return <Navigate to="/account/login" state={{ from: history.location }} />
    }
}